import { Modal, Table, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { renderDate, renderDateTime } from "@/utils";
import { VendorCentralStatusHistoryEntry } from "@/models/invoice";

const { Text } = Typography;

interface VendorCentralStatusHistoryModalProps {
  visible: boolean;
  onClose: () => void;
  statusHistory?: VendorCentralStatusHistoryEntry[];
  currentStatus?: string;
}

export function VendorCentralStatusHistoryModal({
  visible,
  onClose,
  statusHistory,
  currentStatus,
}: VendorCentralStatusHistoryModalProps) {
  const columns: ColumnsType<VendorCentralStatusHistoryEntry> = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "200px",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "200px",
      render: (value: string) => renderDateTime(value) || renderDate(value),
    },
  ];

  // Aggiungi lo status corrente se non è già nella history
  const dataSource = statusHistory ? [...statusHistory] : [];
  if (currentStatus && !dataSource.some((entry) => entry.status === currentStatus)) {
    dataSource.unshift({
      status: currentStatus,
      date: "",
    });
  }

  return (
    <Modal
      title="Vendor Central Status History"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      {dataSource.length === 0 ? (
        <Text>No status history available</Text>
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          rowKey={(record, index) => `${record.status}-${index}`}
          pagination={false}
          size="small"
        />
      )}
    </Modal>
  );
}